module.exports = __webpack_public_path__ + "img/00004.f60d3c6b.webp";